import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Czcionka Roboto (wymagana dla przycisków testu: 400, 500, 600)
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupAudioUnlock } from './services/soundService';
import 'leaflet/dist/leaflet.css';

// Jednorazowa migracja starego klucza wymuszającego tryb mobilny (localStorage -> sessionStorage)
try {
  const legacy = localStorage.getItem('ui:forceMobile');
  if (legacy === '1' || legacy === '0') {
    sessionStorage.setItem('ui:forceMobile', legacy);
    localStorage.removeItem('ui:forceMobile');
  }
} catch {}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Przygotuj odblokowanie audio – po pierwszym kliknięciu w dowolnym miejscu aplikacji
try { setupAudioUnlock(); } catch {}
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
